import {http} from "../util/http.util";

export interface LoginResult {
    success: boolean,
    url: string
}

export const validateEditor = () => {
    return http.post<LoginResult>('/api/editor/sso/validate');
}